import { AcceptAllButton } from '../TrackChangesButtons/AcceptAllButton'
import { RejectAllButton } from '../TrackChangesButtons/RejectAllButton'
import { TrackChangesButton } from '../TrackChangesButtons/TrackChangesButton'
import { ToggleTrackedChangesButton } from '../TrackChangesButtons/ToggleTrackedChangesButton'
import Styles from './Collaboration.module.scss'
import { observer } from 'mobx-react-lite'
import { useRootStore } from 'stores/RootStore'

export const TrackChanges = observer(() => {
  const { docStore } = useRootStore()

  const count = docStore?.trackedChangesStore.changesCount || 0

  return (
    <div className={Styles.trackChanges}>
      <div className={Styles.trackChangesButtons}>
        <TrackChangesButton />
        <ToggleTrackedChangesButton />
      </div>
      {count > 0 && (
        <div className={Styles.trackChangesButtons}>
          <AcceptAllButton />
          <RejectAllButton />
        </div>
      )}
    </div>
  )
})
